<button (click)="generateQuote()" mat-raised-button class="btn-print-order mr-4">
  Print
</button>
<button mat-raised-button class="btn-new-order" (click)="newOrder()" [hidden]="isHidden">
  New order
</button>
